// Centralised home for variation-related copy. Variation strings are currently
// scattered across orders/sites/claims/boq; migrate them here over time so all
// variation translations live under the `variations` namespace.
export default {
  variation: 'Variation',
  pendingVariation: 'Pending variation',
  itemHasVariation:
    'This item has a pending variation that needs to be approved or denied before it can be added',
};
